import React from "react";
import styled from "styled-components";
import { withTranslation, WithTranslation } from "react-i18next";

import { translate } from "src/locales";
import images from "src/images";
import { Button } from "src/components/Typography";
import { getLinksByLanguage } from "src/constants/link";

type Props = { className?: string } & WithTranslation;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 52px;
  background: #060607;
`;

const Inner = styled(Button)`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #ffffff;
  cursor: pointer;
`;

const VerifiedUserIcon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 4px;
`;

const LinkIcon = styled.img`
  width: 24px;
  height: 24px;
  margin-left: 4px;
`;

const ISMSBanner = (props: Props) => {
  const { className, t, i18n } = props;
  const language = i18n.language;
  const onLink = () => {
    window.open(getLinksByLanguage(language).ismsBanner);
  };

  return (
    <Container className={className}>
      <Inner onClick={onLink}>
        <VerifiedUserIcon
          src={images.verifiedUserSrc}
          srcSet={images.verifiedUser}
        />
        {`가상자산 사업자용 ISMS 준비하기`}
        <LinkIcon
          src={images.arrowRightWhiteSrc}
          srcSet={images.arrowRightWhite}
        />
      </Inner>
    </Container>
  );
};

export default withTranslation()(ISMSBanner);
